/**
 * @generated SignedSource<<038aefd1200b78a17613a72833d69716>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type urlsFragment_gym$data = {
  readonly slug: string;
  readonly " $fragmentType": "urlsFragment_gym";
};
export type urlsFragment_gym$key = {
  readonly " $data"?: urlsFragment_gym$data;
  readonly " $fragmentSpreads": FragmentRefs<"urlsFragment_gym">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "urlsFragment_gym",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "slug",
      "storageKey": null
    }
  ],
  "type": "GymType",
  "abstractKey": null
};

(node as any).hash = "4f1c7a79f0fc2d91b3a417dd194d887d";

export default node;
